import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { forwardRef, useMemo } from 'react';

import Heading from 'shopper/components/Heading';
import Tag from 'shopper/components/Tag/V2';

import { toStoreCouponsLink } from 'lib/links';
import { trackEvent } from 'lib/posthog';

const MAX_STORES = 9;

const RelatedStores = forwardRef(
  ({ storeName, storeSlug, stores = [] }, ref) => {
    const filtered = useMemo(
      () =>
        stores.filter((s) => s.storeSlug !== storeSlug).slice(0, MAX_STORES),
      [stores, storeSlug]
    );

    if (filtered.length === 0) return null;

    return (
      <div ref={ref}>
        <Heading as="h2" size="size6">
          Pessoas que usaram cupom {storeName} também viram
        </Heading>
        <div className="mt-4 flex flex-wrap gap-2">
          {filtered.map(({ storeName: name, storeSlug: slug }) => (
            <NextLink
              key={slug}
              href={toStoreCouponsLink(slug)}
              prefetch={false}
              passHref
            >
              <Tag
                as="a"
                className="text-sm"
                size="size3"
                clickable
                onClick={() =>
                  trackEvent('click sidebar store', {
                    source_type: 'navigation',
                    source_value: 'related_stores',
                    option: slug,
                  })
                }
              >
                {name}
              </Tag>
            </NextLink>
          ))}
        </div>
        <hr className="my-6 border-neutral-high-300 dark:border-neutral-low-200" />
      </div>
    );
  }
);

RelatedStores.displayName = 'RelatedStores';

RelatedStores.propTypes = {
  storeName: PropTypes.string.isRequired,
  storeSlug: PropTypes.string.isRequired,
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      storeName: PropTypes.string.isRequired,
      storeSlug: PropTypes.string.isRequired,
    })
  ),
};

export default RelatedStores;
